import { render } from "./portletTemplateDetailView.vue?vue&type=template&id=2d1996bf&scoped=true"
import script from "./portletTemplateDetailView.vue?vue&type=script&lang=js"
export * from "./portletTemplateDetailView.vue?vue&type=script&lang=js"

import "./portletTemplateDetailView.vue?vue&type=style&index=0&id=2d1996bf&scoped=true&lang=css"
import "./portletTemplateDetailView.vue?vue&type=style&index=1&id=2d1996bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d1996bf"]])

export default __exports__